<script setup lang="ts">
import './assets/style.scss'
import { VModal, VSelectSearch } from '@/shared/ui'
import { useInventObjectCreateModal } from './../model/model.ts'
import { ObjectTypeFunctionalType } from '@/entities/Manuals/ObjectTypes'
import { computed, type PropType, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const props = defineProps({
  functionalType: {
    type: String as PropType<ObjectTypeFunctionalType>,
    required: true,
  },
  dependencies: {
    type: Array as PropType<number[]>,
    default: () => [],
  },
})

const store = useInventObjectCreateModal()

/** Вычисляем значение фильтр */
const route = useRoute()
const objectId = computed(() => Number(route.params.object_id))

const loadFilter = computed(() => ({
  coords: store.pointCoords,
  types: props.dependencies,
  radius: 1000,
}))

const { isLoading } = store.loadData(objectId, loadFilter)

/* Следим за изменениями типа */
watch(
  () => props.functionalType,
  () => {
    store.type = props.functionalType
  },
  {
    immediate: true,
  },
)

const valid = ref(false)
</script>

<template>
  <VModal v-model="store.open" :title="$t('itf.object_create_optional_data')">
    <VForm v-model="valid" @submit.prevent="store.confirm">
      <p v-if="store.type == ObjectTypeFunctionalType.UNIVERSAL" class="text_small mb-4">
        {{ $t('itf.map_group_not_optional') }}
      </p>

      <VSelectSearch
        v-model="store.data.dependency"
        :label="$t('itf.dependencies')"
        :rules="store.rules.dependency"
        :items="store.objectList"
        :loading="isLoading"
      />

      <div class="mt-2 form__btn_right">
        <VBtn color="default" variant="tonal" @click="store.cancel">
          {{ $t('itf.cancel') }}
        </VBtn>

        <VBtn type="submit">{{ $t('itf.add') }}</VBtn>
      </div>
    </VForm>
  </VModal>
</template>
